import { durationLabel, PriceEstimate, RentalWindowPricing, parseWall, wallDayLabel, wallTime } from 'utils/shortTerm'
import useTranslation from 'hooks/useTranslation'
import { displayPrice } from 'utils/string'
import React from 'react'

interface RentalWindowSummaryProps {
  startDateTime?: string
  durationMinutes: number
  pricing?: PriceEstimate | RentalWindowPricing
  /** cena z koszyka (true) albo podgląd z siatki cennika (false — dopisek „szacunkowo") */
  isConfirmed?: boolean
  notice?: string
}

/** podsumowanie okna najmu: odbiór, zwrot, czas, cena */
const RentalWindowSummary: React.FC<RentalWindowSummaryProps> = ({ startDateTime, durationMinutes, pricing, isConfirmed = false, notice }) => {
  const { t, lang } = useTranslation('calendar.shortTerm')
  const start = parseWall(startDateTime)
  if (start === undefined) return null
  const end = start + durationMinutes
  const fullDate = (m: number) => `${wallDayLabel(m, lang, { weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric' })}, ${wallTime(m)}`

  return (
    <div className='shortTermCalendar__summary'>
      <div className='shortTermCalendar__summary__row'>
        <span>{t('pickup')}</span>
        <b>{fullDate(start)}</b>
      </div>
      <div className='shortTermCalendar__summary__row'>
        <span>{t('return')}</span>
        <b>{fullDate(end)}</b>
      </div>
      <div className='shortTermCalendar__summary__row'>
        <span>{t('rentalTime')}</span>
        <b>{durationLabel(durationMinutes, lang)}</b>
      </div>
      {pricing && <div className='shortTermCalendar__summary__row --price'>
        <span>{t('price')}{!isConfirmed ? ` (${t('estimated')})` : ''}</span>
        <b>
          {pricing.quantity > 1 && <small>{pricing.quantity} × {displayPrice(pricing.unitRateGross)} / {t(`units.${pricing.unit}`)} = </small>}
          {displayPrice(pricing.gross)}
        </b>
      </div>}
      {notice && <div className='shortTermCalendar__summary__notice'>{notice}</div>}
    </div>
  )
}

export default RentalWindowSummary
